module.exports = __webpack_public_path__ + "img/online01.cb147a11.jpg";